//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "QfPDisplay",
    props: { value: [String, Boolean] },
    data() {
        return {
            values: [
                { value: "inline", icon: "mdi-format-float-left" },
                { value: "block", icon: "mdi-format-float-center" },
                { value: "inline-block", icon: "mdi-format-float-none" },
                { value: "none", icon: "mdi-eye-off" }
            ]
        };
    },
    methods: {
        buttonClass(value) {
            const classes = ["fix25", "q-pa-none"];

            if (this.value === value) {
                classes.push("selected");
            }

            return classes;
        },
        update(value) {
            this.value = value;
            this.$emit("input", this.value);
        }
    }
};
